import { type ReactNode } from 'react';

export const IsActive = ({
  children,
  isActive = false,
}: {
  children: ReactNode;
  isActive?: boolean;
}) => <>{isActive ? children : null}</>;
